import React from 'react';
import { Link } from 'react-router-dom';


const ActiveRow = ( { newCard, numero, estado, isChildRow, estadoGlobal, row, toggleModalAptoNuevaTarjeta }) => {

    if ( isChildRow ) {

        let estadoClass = "";
        let estadoDesc = "";
        switch (estado) {
            case 0:
            case 'Bloqueada':
                estadoDesc = 'BAJA';
                estadoClass = 'danger';
                break;
            case 1:
            case 'Activa':
                estadoDesc = 'ACTIVA';
                estadoClass = 'active';
                break;
            case 2:
                estadoDesc = 'NUEVA';
                estadoClass = 'new';
                break;
            case 3:
                estadoDesc = 'REIMRPESA';
                estadoClass = 'warning';
                break;

            case 'P':
            case 'p':
                estadoDesc = 'Pendiente';
                estadoClass = 'pendiente';
                break;
            case 'E':
            case 'e':
                estadoDesc = 'Error';
                estadoClass = 'error';
                break;
            case 'T':
            case 't':
                estadoDesc = 'En tramite';
                estadoClass = 'en-tramite';
                break;

        }

        return (
            <div className={"div-" + estadoClass + " text-white"}>
                {estadoDesc}
            </div>
        );
    }
    else {

        const newCardText = newCard ? "Nueva tarjeta" : "";

        if ( newCard ) {
            return (
                <span>
                    <a className="NuevaTarjeta" onClick={() => toggleModalAptoNuevaTarjeta( numero )}>
                        <span className="zmdi zmdi-plus-circle-o"></span>
                        &nbsp;
                {newCardText}
                    </a>
                </span>
            );

        }
        else
            return null;
            
    }
}

export default ActiveRow;
